import Image from "next/image";
import React from "react";

type PropType = {
  selected: boolean;
  index: string;
  onClick: () => void;
};

export const Thumb: React.FC<PropType> = (props) => {
  const { selected, index, onClick } = props;

  return (
    <div
      className={`pr-4 cursor-pointer  overflow-hidden  shrink-0  embla-thumbs__slide`}
    >
      <Image
        alt="Thumb Image"
        height={100}
        width={100}
        src={index}
        onClick={onClick}
        className={`h-[100px]  ${
          selected && "border-[3px] border-themeColor"
        } w-[150px]  rounded-xl object-cover`}
      ></Image>
    </div>
  );
};
